import { useEffect, useRef } from 'react';
import { Button, Row, Spin } from 'antd';
import clsx from 'clsx';

import styles from './index.module.scss';
import { Left } from '../Icon';

interface CarouselScrollProps {
  className?: string;
  loading?: boolean;
  activeId?: string;
  hideControls?: boolean;
}

function CarouselScroll({
  className,
  loading,
  activeId,
  children,
  hideControls = false,
}: React.PropsWithChildren<CarouselScrollProps>) {
  const scrollRef = useRef<HTMLDivElement>(null);

  const handleScroll = (direction: 'left' | 'right') => {
    if (!scrollRef.current) return;

    const container = scrollRef.current;
    const scrollAmount = container.offsetWidth / 2;

    container.scrollBy({
      left: direction === 'left' ? -scrollAmount : scrollAmount,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    if (!activeId || loading) return;

    const el = document.getElementById(activeId);
    const parent = el?.parentElement;

    if (parent) {
      parent.scrollTo({
        left: el.offsetLeft - parent.clientWidth / 2 + el.clientWidth / 2,
        behavior: 'smooth',
      });
    }
  }, [activeId, loading]);

  return (
    <div className={clsx(styles.wrapper, className)}>
      {!hideControls && (
        <Button
          icon={<Left />}
          className={clsx(styles.btnControll, styles.btnLeft)}
          onClick={() => handleScroll('left')}
        />
      )}
      <div
        className={clsx(
          styles.scrollContainer,
          !hideControls && styles.controlls,
        )}
        ref={scrollRef}
      >
        {loading ? (
          <Row justify="center" style={{ width: '100%' }}>
            <Spin />
          </Row>
        ) : (
          children
        )}
      </div>
      {!hideControls && (
        <Button
          icon={<Left />}
          className={clsx(styles.btnControll, styles.btnRight)}
          onClick={() => handleScroll('right')}
        />
      )}
    </div>
  );
}

export default CarouselScroll;
